import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  footerLabel: {
    id: 'edx.authoring.footer.label',
    defaultMessage: 'edX studio footer',
    description: 'Label text for studio(authoring) footer',
  },
  studioLinkLabel: {
    id: 'edx.authoring.footer.studio.link.label.text',
    defaultMessage: 'Studio',
    description: 'Link text for Studio in edx footer',
  },
  lmsLinkLabel: {
    id: 'edx.authoring.footer.lms.link.label.text',
    defaultMessage: 'LMS',
    description: 'Link text for LMS in edx footer',
  },
  releaseNotesLinkLabel: {
    id: 'edx.authoring.footer.release_notes.link.label.text',
    defaultMessage: 'Release notes',
    description: 'Link text for Release notes in edx footer',
  },
  edxDocumentationLinkLabel: {
    id: 'edx.authoring.footer.edx_documentation.link.label.text',
    defaultMessage: 'edX documentation',
    description: 'Link text for edX documentation in edx footer',
  },
  contactUsLinkLabel: {
    id: 'edx.authoring.footer.contact_us.link.label.text',
    defaultMessage: 'Contact us',
    description: 'Link text for Contact us in edx footer',
  },
  termsOfServiceLinkLabel: {
    id: 'authoring.footer.termsOfService.link.label',
    defaultMessage: 'Terms of service',
    description: 'Label for button that links to the terms of service page',
  },
  privacyPolicyLinkLabel: {
    id: 'authoring.footer.privacyPolicy.link.label',
    defaultMessage: 'Privacy policy',
    description: 'Label for button that links to the privacy policy page',
  },
  accessibilityRequestLinkLabel: {
    id: 'authoring.footer.accessibilityRequest.link.label',
    defaultMessage: 'Accessibility accomodation request',
    description: 'Label for button that links to the accessibility accomodation requests page',
  },
  trademarkMessage: {
    id: 'authoring.footer.trademark.message',
    defaultMessage: 'edX, Open edX, and the edX and Open edX logos are registered trademarks of ',
    description: 'Message about the use of logos and names edX and Open edX',
  },
});

export default messages;
